<template>
	<section class="details">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-lg-11">
					<h2 class="details__name">{{judge.full_name}} ({{judge.nationality}})</h2>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-3">
					<div class="details__score-wrapper">
						<span v-if="judge.average_score" class="details__score">{{getScore(judge.average_score)}}</span>
						<span v-if="!judge.average_score" class="details__score">0</span>
						<img v-for="i in 6" v-if="i <= getScore(judge.average_score)" src="/static/img/star-gold.svg" alt="">
						<img v-for="i in 6" v-if="i > getScore(judge.average_score)" src="/static/img/star-empty.svg" alt="">
					</div>
				</div>
				<div class="col-sm-12 col-lg-3">
					<div class="details__reviews-wrapper">
						<span class="details__reviews">{{judge.comments_count}} {{$t('judge.reviews')}}</span>
						<span class="details__info">{{$t('judge.allComments')}}</span>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-11">
					<div class="details__divider"></div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-11">
					<h3 class="details__headline">{{$t('judge.comment')}}</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-lg-11">
					<div class="details__divider"></div>
				</div>
			</div>
		</div>
		<AddCommentComponent @addComment="fetchData"/>
		<FiltersComponents @filterComments="handleFilters"/>
		<CommentsComponent @changePage="fetchComments" @commentRemoved="fetchComments" :comments="comments"/>
	</section>
</template>

<script>
	import AddCommentComponent from './Details/AddCommentComponent'
	import FiltersComponents from './Details/FiltersComponents'
	import CommentsComponent from './Details/CommentsComponent'
	import axios from 'axios'

	export default {
		components: {
			AddCommentComponent,
			FiltersComponents,
			CommentsComponent
		},
		data () {
			return {
				show: false,
				judge: {},
				comments: [],
				filters: {}
			}
		},
		methods: {
			fetchJudge () {
				const qs = require('qs')
				const config = {
					params: {
						page: this.$route.query.page
					},
					paramsSerializer (params) {
						return qs.stringify(params, { indices: false })
					}
				}
				return axios.get('/api/judges/', config, {
				})
					.then(response => {
						this.judge = response.data.results.find(judge => {
							return judge.id === parseInt(this.$route.params.id)
						})
						this.$emit('getJudgeID', this.judge.id)
					})
					.catch(error => {
						console.error(error)
					})
			},
			fetchComments (index) {
				const qs = require('qs')
				const config = {
					params: {
						score: this.filters.activeStar,
						breed: this.filters.activeBreeds,
						breed_group: this.filters.activeGroups,
						page: index
					},
					paramsSerializer (params) {
						return qs.stringify(params, {indices: false})
					}
				}
				axios.get(`/api/judges/${ this.$route.params.id }/comments/`, config, {
				})
					.then(resp => {
						this.comments = { ...resp.data, currentPage: index || 1 }
					})
					.catch(err => {
						console.log(err)
					})
			},
			getScore (score) {
				return Math.round(score)
			},
			fetchData () {
				this.fetchJudge().then(this.fetchComments)
			},
			handleFilters (filters = {}) {
				this.filters = filters
				this.fetchComments()
			}
		},
		created () {
			this.fetchData()
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.details {
		padding: 25px 0;
		background-color: #fff;

		&__divider {
			width: 100%;
			height: 4px;
			background-color: $black;
			margin-bottom: 20px;
		}

		&__name {
			font-family: $lato-bold;
			font-size: 36px;
			text-align: left;
			margin: 0;
			margin-bottom: 15px;
		}
		&__score-wrapper {
			display: flex;
			justify-content: flex-start;
			align-self: center;
			margin-bottom: 20px;
			img {
				margin-right: 5px;
			}
		}
		&__score {
			font-family: $lato-bold;
			font-size: 20px;
			margin-right: 10px;
			color: $gold-score;
		}
		&__reviews-wrapper {
			display: flex;
			justify-content: space-between;
			align-self: center;
		}
		&__reviews {
			font-family: $lato-bold;
			font-size: 16px;
		}
		&__info {
			font-style: italic;
		}
		&__headline {
			font-family: $lato-bold;
			font-size: 20px;
			letter-spacing: 0.05em;
			text-transform: uppercase;
			text-align: left;
			margin: 0;
			margin-bottom: 20px;
		}

	}




	@media (max-width: 991.98px) {
		.details {
			&__divider {
				width: 100%;
			}

			&__name {
				font-size: 20px;
			}
			&__score-wrapper {
				margin-bottom: 15px;
			}
			&__reviews-wrapper {
				margin-bottom: 15px;
			}
			&__reviews {
				font-family: $lato-bold;
				font-size: 16px;
			}
			&__headline {
				font-size: 14px;
			}

		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Judge/DetailsComponent.vue